import { webStore } from '@/store/base';

function getPlatformObject() {
  const platform = webStore.paramManager.getParam('platform');
  switch (platform) {
    case 'alipay':
      return (window as any).my;

    default:
      return (window as any).wx.miniProgram;
  }
}

export function navigateBack() {
  const platformObj = getPlatformObject();

  platformObj.postMessage({
    data: { fromUrl: (window as any).location.pathname },
  });

  platformObj.navigateBack();
}

interface NavigateToOptions {
  url: string;
  success?: (res: any) => void;
  fail?: (res: any) => void;
  complete?: (res: any) => void;
}

function wmpNavigateTo(options: NavigateToOptions): Promise<void> {
  return new Promise((resolve, reject) => {
    (window as any).wx.miniProgram.navigateTo({
      ...options,
      success: (res: any) => {
        options.success?.(res);
        resolve(res);
      },
      fail: (res: any) => {
        options.fail?.(res);
        reject(res);
      },
      complete: (res: any) => {
        options.complete?.(res);
      },
    });
  });
}

function alipayNavigateTo(options: NavigateToOptions): Promise<void> {
  return new Promise((resolve, _reject) => {
    (window as any).my.navigateTo(options);
    resolve();
  });
}

export function navigateTo(options: NavigateToOptions): Promise<void> {
  const platform = webStore.paramManager.getParam('platform');
  switch (platform) {
    case 'alipay':
      return alipayNavigateTo(options);

    default:
      return wmpNavigateTo(options);
  }
}
